import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    OpenBirdActionMenu: 'birdActionMenu/open',
    SelectBirdActionMenuOption: 'birdActionMenu/select',
    CloseBirdActionMenu: 'birdActionMenu/close',
};
const initialState = {
    context: '',
    items: [],
    position: { x: 0, y: 0 },
};
export const BirdActionMenuState = {
    elementName: 'birdActionMenu',
    actions: {
        open: (args) => action(AT.OpenBirdActionMenu, args),
        select: (context, index) => action(AT.SelectBirdActionMenuOption, { context, index }),
        close: () => action(AT.CloseBirdActionMenu),
    },
    actionTypes: AT,
    reducer: createReducer(initialState, {
        [AT.OpenBirdActionMenu]: (_state, action) => {
            return Object.assign({}, action.payload);
        },
        [AT.CloseBirdActionMenu]: () => {
            return initialState;
        },
    }),
};
